
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { float64_type, class_type, tuple_type, bool_type, list_type, record_type, option_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { sumBy, mapFold, length, filter, skipWhile, fold, takeWhile, map as map_1, forAll, choose, empty, tail as tail_1, head, isEmpty, cons, reverse, append, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { trim, join, compare, substring, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { filter as filter_1, orElse, map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { ofList, tryPick, tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { LabelConfiguration_$reflection, LabelTextLine_$reflection, LabelConfiguration, LabelFontSize, LabelCodePosition, LabelCodeType, LabelTextLines, LabelTextLine } from "./Shared.js";
import { equals, comparePrimitives } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { map as map_2, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { isLetterOrDigit } from "../fable_modules/fable-library-js.5.0.0-rc.2/Char.js";
import { max, min } from "../fable_modules/fable-library-js.5.0.0-rc.2/Double.js";

export class LabelInventoryKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "Set", "ToolWithQuantity", "Consumable"];
    }
}

export function LabelInventoryKind_$reflection() {
    return union_type("Shared.Label.LabelInventoryKind", [], LabelInventoryKind, () => [[], [], [], []]);
}

export const Placeholder_name = "name";

export const Placeholder_inventoryNumber = "inventory_number";

export const Placeholder_storage = "storage";

export const Placeholder_storageSpace = "storage_space";

export const Placeholder_category = "category";

export const Placeholder_businessUnit = "business_unit";

export const Placeholder_code = "code";

export const Placeholder_supplier = "supplier";

export const Placeholder_purchaseDate = "purchase_date";

export const Placeholder_manufacturer = "manufacturer";

export const Placeholder_model = "model";

export const Placeholder_serialNumber = "serial_number";

export const Placeholder_nextInspection = "next_inspection";

export const Placeholder_contentCount = "content_count";

export const Placeholder_stock = "stock";

export const Placeholder_minimumStock = "minimum_stock";

export const Placeholder_additionalName = "additional_name";

export const Placeholder_description = "description";

export const Placeholder_unit = "unit";

export const Placeholder_customPropertyPrefix = "property:";

export const Placeholder_common = ofArray([Placeholder_name, Placeholder_inventoryNumber, Placeholder_storage, Placeholder_storageSpace, Placeholder_category, Placeholder_businessUnit, Placeholder_code, Placeholder_supplier, Placeholder_purchaseDate]);

export function Placeholder_forKind(kind) {
    return append(Placeholder_common, (kind.tag === 1) ? ofArray([Placeholder_manufacturer, Placeholder_model, Placeholder_serialNumber, Placeholder_contentCount]) : ((kind.tag === 2) ? ofArray([Placeholder_manufacturer, Placeholder_model, Placeholder_stock, Placeholder_minimumStock]) : ((kind.tag === 3) ? ofArray([Placeholder_additionalName, Placeholder_description, Placeholder_unit, Placeholder_stock, Placeholder_minimumStock]) : ofArray([Placeholder_manufacturer, Placeholder_model, Placeholder_serialNumber, Placeholder_nextInspection]))));
}

export function Placeholder_customProperty(propertyName) {
    return concat(Placeholder_customPropertyPrefix, ...propertyName);
}

export function Placeholder_wrap(placeholder) {
    return ("{" + placeholder) + "}";
}

export class LabelSegment extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Literal", "Placeholder"];
    }
}

export function LabelSegment_$reflection() {
    return union_type("Shared.Label.LabelSegment", [], LabelSegment, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export function parse(content) {
    const loop = (rest_mut, acc_mut) => {
        loop:
        while (true) {
            const rest = rest_mut, acc = acc_mut;
            if (rest === "") {
                return reverse(acc);
            }
            else {
                const matchValue = rest.indexOf("{") | 0;
                if (matchValue === -1) {
                    return reverse(cons(new LabelSegment(0, [rest]), acc));
                }
                else {
                    const openIndex = matchValue | 0;
                    const closeIndex = rest.indexOf("}", openIndex + 1) | 0;
                    const nextOpen = rest.indexOf("{", openIndex + 1) | 0;
                    if ((closeIndex === -1) ? true : ((nextOpen !== -1) && (nextOpen < closeIndex))) {
                        const literal = substring(rest, 0, openIndex + 1);
                        const acc_1 = !isEmpty(acc) ? ((head(acc).tag === 0) ? cons(new LabelSegment(0, [head(acc).fields[0] + literal]), tail_1(acc)) : cons(new LabelSegment(0, [literal]), acc)) : cons(new LabelSegment(0, [literal]), acc);
                        rest_mut = substring(rest, openIndex + 1);
                        acc_mut = acc_1;
                        continue loop;
                    }
                    else {
                        const acc_2 = (openIndex > 0) ? cons(new LabelSegment(0, [substring(rest, 0, openIndex)]), acc) : acc;
                        const placeholder = substring(rest, openIndex + 1, (closeIndex - openIndex) - 1).trim();
                        rest_mut = substring(rest, closeIndex + 1);
                        acc_mut = cons(new LabelSegment(1, [placeholder]), acc_2);
                        continue loop;
                    }
                }
            }
            break;
        }
    };
    return loop(content, empty());
}

export function placeholdersOf(content) {
    return choose((_arg) => {
        if (_arg.tag === 0) {
            return undefined;
        }
        else {
            return _arg.fields[0];
        }
    }, parse(content));
}

function lookup(values, placeholder) {
    return defaultArg(map((value_1) => value_1.trim(), orElse(tryFind(placeholder, values), tryPick((key, value) => {
        if (compare(key, placeholder, 5) === 0) {
            return value;
        }
        else {
            return undefined;
        }
    }, values))), "");
}

export function resolve(values, content) {
    const segments = parse(content);
    if (forAll((_arg) => {
        if (_arg.tag === 1) {
            return false;
        }
        else {
            return true;
        }
    }, segments)) {
        return content.trim();
    }
    else {
        const leading = join("", map_1((_arg_2) => {
            if (_arg_2.tag === 1) {
                return "";
            }
            else {
                return _arg_2.fields[0];
            }
        }, takeWhile((_arg_1) => {
            if (_arg_1.tag === 1) {
                return false;
            }
            else {
                return true;
            }
        }, segments)));
        const patternInput = fold((tupledArg, tupledArg_1) => {
            const output = tupledArg[0];
            const pending = tupledArg[1];
            const value_1 = tupledArg_1[0];
            if (value_1 === "") {
                return [output, pending, tupledArg[2], true];
            }
            else {
                return [(output + pending) + value_1, tupledArg_1[1], true, false];
            }
        }, ["", "", false, false], reverse(fold((pairs, segment) => {
            if (segment.tag === 0) {
                if (isEmpty(pairs)) {
                    return pairs;
                }
                else {
                    return cons([head(pairs)[0], head(pairs)[1] + segment.fields[0]], tail_1(pairs));
                }
            }
            else {
                return cons([lookup(values, segment.fields[0]), ""], pairs);
            }
        }, empty(), skipWhile((_arg_3) => {
            if (_arg_3.tag === 1) {
                return false;
            }
            else {
                return true;
            }
        }, segments))));
        if (!patternInput[2]) {
            return "";
        }
        else {
            return ((leading + patternInput[0]) + (patternInput[3] ? "" : patternInput[1])).trim();
        }
    }
}

export function resolveLines(values, lines) {
    return filter((line_2) => (line_2.Content !== ""), map_1((line_1) => (new LabelTextLine(resolve(values, line_1.Content), line_1.FontSize, line_1.Bold)), lines));
}

export function textLinesFor(kind, textLines) {
    switch (kind.tag) {
        case 1:
            return textLines.SetLines;
        case 2:
            return textLines.ToolWithQuantityLines;
        case 3:
            return textLines.ConsumableLines;
        default:
            return textLines.ToolLines;
    }
}

export function withTextLinesFor(kind, lines, textLines) {
    switch (kind.tag) {
        case 1:
            return new LabelTextLines(textLines.ToolLines, lines, textLines.ToolWithQuantityLines, textLines.ConsumableLines);
        case 2:
            return new LabelTextLines(textLines.ToolLines, textLines.SetLines, lines, textLines.ConsumableLines);
        case 3:
            return new LabelTextLines(textLines.ToolLines, textLines.SetLines, textLines.ToolWithQuantityLines, lines);
        default:
            return new LabelTextLines(lines, textLines.SetLines, textLines.ToolWithQuantityLines, textLines.ConsumableLines);
    }
}

export const maxTextLines = 4;

export const maxLabelsPerPrint = 500;

export const maxPrefixLength = 4;

export const minimumSizeMm = 10;

export const maximumSizeMm = 300;

export const sizePresets = ofArray([[25, 13], [40, 22], [72, 42]]);

export function activeConfiguration(customerConfiguration) {
    return filter_1((configuration) => configuration.Enabled, customerConfiguration.LabelConfiguration);
}

export const sampleCodeBody = "PR0BEDRK";

export function sampleCodeFor(prefix) {
    return prefix.trim().toUpperCase() + sampleCodeBody;
}

export const sampleCode = sampleCodeFor("ONE-");

function line(content, fontSize, bold) {
    return new LabelTextLine(content, fontSize, bold);
}

export const defaultConfiguration = new LabelConfiguration(40, 22, 1.5, new LabelCodeType(0, []), new LabelCodePosition(0, []), true, false, "", new LabelTextLines(ofArray([line("{name}", new LabelFontSize(3, []), true), line("{manufacturer} {model}", new LabelFontSize(3, []), false), line("{storage} · {storage_space}", new LabelFontSize(3, []), false)]), ofArray([line("{name}", new LabelFontSize(3, []), true), line("{manufacturer} {model}", new LabelFontSize(3, []), false), line("{storage} · {storage_space}", new LabelFontSize(3, []), false)]), ofArray([line("{name}", new LabelFontSize(3, []), true), line("{manufacturer} {model}", new LabelFontSize(3, []), false), line("{storage} · {storage_space}", new LabelFontSize(3, []), false)]), ofArray([line("{name}", new LabelFontSize(3, []), true), line("{additional_name}", new LabelFontSize(3, []), false), line("{storage} · {storage_space}", new LabelFontSize(3, []), false)])), true);

export function sampleValues(kind) {
    return ofList(append(ofArray([[Placeholder_inventoryNumber, "INV-00124"], [Placeholder_storage, "Hauptlager"], [Placeholder_storageSpace, "Regal 3 / Fach B"], [Placeholder_category, "Elektrowerkzeug"], [Placeholder_businessUnit, "Montage Nord"], [Placeholder_code, sampleCode], [Placeholder_supplier, "Werkzeughandel Müller"], [Placeholder_purchaseDate, "12.03.2025"]]), (kind.tag === 1) ? ofArray([[Placeholder_name, "Montagekoffer Elektro"], [Placeholder_manufacturer, "Wiha"], [Placeholder_model, "Profi 42"], [Placeholder_serialNumber, "SET-2024-07"], [Placeholder_contentCount, "12"]]) : ((kind.tag === 2) ? ofArray([[Placeholder_name, "VDE-Schraubendreher"], [Placeholder_manufacturer, "Wera"], [Placeholder_model, "Kraftform"], [Placeholder_stock, "24"], [Placeholder_minimumStock, "10"]]) : ((kind.tag === 3) ? ofArray([[Placeholder_name, "Spanplattenschraube"], [Placeholder_additionalName, "4 × 40 mm"], [Placeholder_description, "Teilgewinde, verzinkt"], [Placeholder_unit, "Packung"], [Placeholder_stock, "48"], [Placeholder_minimumStock, "20"]]) : ofArray([[Placeholder_name, "Akku-Bohrschrauber"], [Placeholder_manufacturer, "Bosch"], [Placeholder_model, "GSR 12V-15"], [Placeholder_serialNumber, "SN-4471-02"], [Placeholder_nextInspection, "30.04.2027"]])))), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
}

function sanitizeFileNamePart(value) {
    let value_1;
    return trim((value_1 = toArray(map_2((character) => {
        if ((isLetterOrDigit(character) ? true : (character === "-")) ? true : (character === "_")) {
            return character;
        }
        else {
            return "-";
        }
    }, value.split(""))), value_1.join('')), "-");
}

export function fileName(code, storageName) {
    const matchValue = filter_1((name) => (name !== ""), map(sanitizeFileNamePart, storageName));
    if (matchValue == null) {
        return concat("etikett-", sanitizeFileNamePart(code), ...".pdf");
    }
    else {
        const storage = matchValue;
        return `etikett-${sanitizeFileNamePart(code)}-${storage}.pdf`;
    }
}

export class LabelPrintItem extends Record {
    constructor(Kind, EntityId, StorageId, PreferredCode) {
        super();
        this.Kind = Kind;
        this.EntityId = EntityId;
        this.StorageId = StorageId;
        this.PreferredCode = PreferredCode;
    }
}

export function LabelPrintItem_$reflection() {
    return record_type("Shared.Label.LabelPrintItem", [], LabelPrintItem, () => [["Kind", LabelInventoryKind_$reflection()], ["EntityId", string_type], ["StorageId", option_type(string_type)], ["PreferredCode", option_type(string_type)]]);
}

export class LabelPrintCandidate extends Record {
    constructor(Kind, EntityId, StorageId, StorageName, DisplayName, ExistingCodes, HasStock) {
        super();
        this.Kind = Kind;
        this.EntityId = EntityId;
        this.StorageId = StorageId;
        this.StorageName = StorageName;
        this.DisplayName = DisplayName;
        this.ExistingCodes = ExistingCodes;
        this.HasStock = HasStock;
    }
}

export function LabelPrintCandidate_$reflection() {
    return record_type("Shared.Label.LabelPrintCandidate", [], LabelPrintCandidate, () => [["Kind", LabelInventoryKind_$reflection()], ["EntityId", string_type], ["StorageId", option_type(string_type)], ["StorageName", string_type], ["DisplayName", string_type], ["ExistingCodes", list_type(string_type)], ["HasStock", bool_type]]);
}

export class LabelPrintRequest extends Record {
    constructor(Items, AssignCodes) {
        super();
        this.Items = Items;
        this.AssignCodes = AssignCodes;
    }
}

export function LabelPrintRequest_$reflection() {
    return record_type("Shared.Label.LabelPrintRequest", [], LabelPrintRequest, () => [["Items", list_type(LabelPrintItem_$reflection())], ["AssignCodes", bool_type]]);
}

export class LabelCodeOrigin extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Existing", "Assigned", "Reserved"];
    }
}

export function LabelCodeOrigin_$reflection() {
    return union_type("Shared.Label.LabelCodeOrigin", [], LabelCodeOrigin, () => [[], [], []]);
}

export class PrintedLabel extends Record {
    constructor(Kind, EntityId, StorageId, Code, CodeOrigin, FileName, Lines) {
        super();
        this.Kind = Kind;
        this.EntityId = EntityId;
        this.StorageId = StorageId;
        this.Code = Code;
        this.CodeOrigin = CodeOrigin;
        this.FileName = FileName;
        this.Lines = Lines;
    }
}

export function PrintedLabel_$reflection() {
    return record_type("Shared.Label.PrintedLabel", [], PrintedLabel, () => [["Kind", LabelInventoryKind_$reflection()], ["EntityId", string_type], ["StorageId", option_type(string_type)], ["Code", string_type], ["CodeOrigin", LabelCodeOrigin_$reflection()], ["FileName", string_type], ["Lines", list_type(LabelTextLine_$reflection())]]);
}

export class LabelPrintResponse extends Record {
    constructor(Configuration, Labels) {
        super();
        this.Configuration = Configuration;
        this.Labels = Labels;
    }
}

export function LabelPrintResponse_$reflection() {
    return record_type("Shared.Label.LabelPrintResponse", [], LabelPrintResponse, () => [["Configuration", LabelConfiguration_$reflection()], ["Labels", list_type(PrintedLabel_$reflection())]]);
}

export class LabelPreviewData extends Record {
    constructor(Code, Values) {
        super();
        this.Code = Code;
        this.Values = Values;
    }
}

export function LabelPreviewData_$reflection() {
    return record_type("Shared.Label.LabelPreviewData", [], LabelPreviewData, () => [["Code", option_type(string_type)], ["Values", list_type(tuple_type(string_type, string_type))]]);
}

export class ReservedQrCodeDto extends Record {
    constructor(Code, CreatedAt, CreatedByUserId) {
        super();
        this.Code = Code;
        this.CreatedAt = CreatedAt;
        this.CreatedByUserId = CreatedByUserId;
    }
}

export function ReservedQrCodeDto_$reflection() {
    return record_type("Shared.Label.ReservedQrCodeDto", [], ReservedQrCodeDto, () => [["Code", string_type], ["CreatedAt", class_type("System.DateTime")], ["CreatedByUserId", string_type]]);
}

export class LabelBox extends Record {
    constructor(X, Y, Width, Height) {
        super();
        this.X = X;
        this.Y = Y;
        this.Width = Width;
        this.Height = Height;
    }
}

export function LabelBox_$reflection() {
    return record_type("Shared.Label.LabelBox", [], LabelBox, () => [["X", float64_type], ["Y", float64_type], ["Width", float64_type], ["Height", float64_type]]);
}

export class LabelLayout extends Record {
    constructor(CodeBox, CodeValueBox, TextBox, LogoBox) {
        super();
        this.CodeBox = CodeBox;
        this.CodeValueBox = CodeValueBox;
        this.TextBox = TextBox;
        this.LogoBox = LogoBox;
    }
}

export function LabelLayout_$reflection() {
    return record_type("Shared.Label.LabelLayout", [], LabelLayout, () => [["CodeBox", option_type(LabelBox_$reflection())], ["CodeValueBox", option_type(LabelBox_$reflection())], ["TextBox", option_type(LabelBox_$reflection())], ["LogoBox", option_type(LabelBox_$reflection())]]);
}

export const Layout_codeValueHeightMm = 2.4;

export const Layout_gapMm = 1.2;

export const Layout_logoHeightMm = 4;

function Layout_box(x, y, width, height) {
    return new LabelBox(x, y, width, height);
}

function Layout_withLogo(configuration, textBox) {
    let matchResult, text_1;
    if (configuration.ShowLogo) {
        if (textBox != null) {
            if (textBox.Height > (Layout_logoHeightMm * 2)) {
                matchResult = 0;
                text_1 = textBox;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const logoHeight = min(Layout_logoHeightMm, text_1.Height * 0.25);
            const logoWidth = min(logoHeight * 3, text_1.Width);
            return [Layout_box((text_1.X + text_1.Width) - logoWidth, text_1.Y, logoWidth, logoHeight), Layout_box(text_1.X, (text_1.Y + logoHeight) + (Layout_gapMm / 2), text_1.Width, (text_1.Height - logoHeight) - (Layout_gapMm / 2))];
        }
        default:
            return [undefined, textBox];
    }
}

export function Layout_layout(configuration) {
    const margin = configuration.MarginMm;
    const innerX = margin;
    const innerY = margin;
    const innerWidth = max(1, configuration.WidthMm - (2 * margin));
    const innerHeight = max(1, configuration.HeightMm - (2 * margin));
    const valueHeight = configuration.ShowCodeValue ? Layout_codeValueHeightMm : 0;
    const isBarcode = equals(configuration.CodeType, new LabelCodeType(1, []));
    const codeBoxes = (x, y, width, height) => {
        const codeHeight = max(1, height - valueHeight);
        let codeBox;
        if (isBarcode) {
            codeBox = Layout_box(x, y, width, codeHeight);
        }
        else {
            const side = min(width, codeHeight);
            codeBox = Layout_box(x + ((width - side) / 2), y, side, side);
        }
        return [codeBox, configuration.ShowCodeValue ? Layout_box(x, codeBox.Y + codeBox.Height, width, valueHeight) : undefined];
    };
    let patternInput_4;
    const matchValue = configuration.CodePosition;
    switch (matchValue.tag) {
        case 0: {
            const codeWidth = isBarcode ? (innerWidth * 0.45) : max(1, min(innerHeight - valueHeight, innerWidth * 0.4));
            const patternInput_1 = codeBoxes(innerX, innerY, codeWidth, innerHeight);
            patternInput_4 = [patternInput_1[0], patternInput_1[1], Layout_box((innerX + codeWidth) + Layout_gapMm, innerY, (innerWidth - codeWidth) - Layout_gapMm, innerHeight)];
            break;
        }
        case 1: {
            const codeWidth_1 = isBarcode ? (innerWidth * 0.45) : max(1, min(innerHeight - valueHeight, innerWidth * 0.4));
            const patternInput_2 = codeBoxes((innerX + innerWidth) - codeWidth_1, innerY, codeWidth_1, innerHeight);
            patternInput_4 = [patternInput_2[0], patternInput_2[1], Layout_box(innerX, innerY, (innerWidth - codeWidth_1) - Layout_gapMm, innerHeight)];
            break;
        }
        case 2: {
            const codeHeight_1 = isBarcode ? (innerHeight * 0.4) : min(innerWidth, innerHeight * 0.5);
            const patternInput_3 = codeBoxes(innerX, innerY, innerWidth, codeHeight_1);
            patternInput_4 = [patternInput_3[0], patternInput_3[1], Layout_box(innerX, (innerY + codeHeight_1) + Layout_gapMm, innerWidth, (innerHeight - codeHeight_1) - Layout_gapMm)];
            break;
        }
        default: {
            const patternInput = codeBoxes(innerX, innerY, innerWidth, innerHeight);
            patternInput_4 = [patternInput[0], patternInput[1], undefined];
        }
    }
    const patternInput_5 = Layout_withLogo(configuration, patternInput_4[2]);
    return new LabelLayout(patternInput_4[0], patternInput_4[1], patternInput_5[1], patternInput_5[0]);
}

const Layout_pointsPerMm = 72 / 25.4;

const Layout_mmPerPoint = 25.4 / 72;

export const Layout_lineSpacing = 1.15;

export const Layout_minimumFontSizePt = 4;

export const Layout_maximumAutoFontSizePt = 14;

export function Layout_fixedFontSizePt(fontSize) {
    switch (fontSize.tag) {
        case 1:
            return 7;
        case 2:
            return 10;
        case 3:
            return Layout_maximumAutoFontSizePt;
        default:
            return 5;
    }
}

export function Layout_lineHeightOf(fontSizePt) {
    return (fontSizePt * Layout_mmPerPoint) * Layout_lineSpacing;
}

export class Layout_PlacedLine extends Record {
    constructor(Line, FontSizePt, Y, Height) {
        super();
        this.Line = Line;
        this.FontSizePt = FontSizePt;
        this.Y = Y;
        this.Height = Height;
    }
}

export function Layout_PlacedLine_$reflection() {
    return record_type("Shared.Label.Layout.PlacedLine", [], Layout_PlacedLine, () => [["Line", LabelTextLine_$reflection()], ["FontSizePt", float64_type], ["Y", float64_type], ["Height", float64_type]]);
}

export function Layout_placeLines(measureWidthMm, textBox, lines) {
    const availablePerLine = isEmpty(lines) ? textBox.Height : (textBox.Height / length(lines));
    const sized = map_1((line_2) => {
        let line_1, matchValue, shrink;
        return [line_2, (line_1 = line_2, (matchValue = line_1.FontSize, (matchValue.tag === 3) ? ((shrink = ((size_mut) => {
            shrink:
            while (true) {
                const size = size_mut;
                if ((size <= Layout_minimumFontSizePt) ? true : (measureWidthMm(size, line_1.Bold, line_1.Content) <= textBox.Width)) {
                    return max(Layout_minimumFontSizePt, size);
                }
                else {
                    size_mut = (size - 0.5);
                    continue shrink;
                }
                break;
            }
        }), shrink(min(Layout_maximumAutoFontSizePt, availablePerLine / (Layout_mmPerPoint * Layout_lineSpacing))))) : Layout_fixedFontSizePt(matchValue)))];
    }, lines);
    return mapFold((y_1, tupledArg_1) => {
        const fontSizePt_1 = tupledArg_1[1];
        const height = Layout_lineHeightOf(fontSizePt_1);
        return [new Layout_PlacedLine(tupledArg_1[0], fontSizePt_1, y_1, height), y_1 + height];
    }, textBox.Y + max(0, (textBox.Height - sumBy((tupledArg) => Layout_lineHeightOf(tupledArg[1]), sized, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    })) / 2), sized)[0];
}

export function Layout_codeValueFontSizePt(valueBox) {
    return max(3.5, min(7, (valueBox.Height * 0.8) * Layout_pointsPerMm));
}

